import { css } from '@emotion/css';

export const glowingEffect = css`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -3px;
    background: linear-gradient(45deg, #228be6, #40c057);
    border-radius: 8px;
    filter: blur(8px);
    opacity: 0;
    transition: opacity 0.3s;
    z-index: -1;
  }
  &:not(:has(button:disabled))::after {
    animation: glow 2s infinite;
  }
  @keyframes glow {
    0%,
    100% {
      opacity: 0.3;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

export const glowingEffectForText = css`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 5px;
    inset-inline-start: -2px;
    inset-inline-end: -2px;
    background: linear-gradient(45deg, #228be6, #40c057);
    border-radius: 8px;
    filter: blur(8px);
    opacity: 0;
    transition: opacity 0.3s;
    z-index: -1;
  }
  &:not(:has(button:disabled))::after {
    animation: glow 3s infinite;
  }
  @keyframes glow {
    0%,
    100% {
      opacity: 0.3;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

export const auraEffect = css`
  filter: drop-shadow(0 0 6px #c1c2c5);
`;

export const blobAnimation = css`
  position: relative;

  &::before,
  &::after,
  & > span {
    content: '';
    position: absolute;
    border-radius: 50%;
    animation: fly 5.8s linear infinite alternate;
  }

  &::before {
    width: 14px;
    height: 14px;
    top: 25px;
    left: -40px;
    background: #d9480f;
    animation-delay: 0.9s;
  }

  &::after {
    width: 18px;
    height: 18px;
    background: #5f3dc4;
    right: -10px;
    top: -40px;
    animation-delay: 0.2s;
  }

  & > span {
    width: 12px;
    height: 12px;
    background: #1DB954;
    right: -55px;
    top: 50%;
    animation-delay: 1.8s;
  }

  @keyframes fly {
    40% {
      transform: translate(-6px, -6px);
    }
    60% {
      transform: translate(-12px, -2px);
    }
    100% {
      transform: translate(0px, 0px);
    }
  }
`;